import { Iproduct } from '../models';
import { parseServerDate } from './serverDate';

const toDate = (value: unknown): Date | null => {
    const t = parseServerDate(value as string | Date | null | undefined);
    return Number.isFinite(t) ? new Date(t) : null;
};

export function getMostRecentDate(product: Iproduct, compareDate: Date): Date | null {
    const { createDate, updateDate } = product;

    const createDateObj = toDate(createDate);
    const updateDateObj = toDate(updateDate);

    const mostRecentForProduct =
        createDateObj && updateDateObj
            ? createDateObj > updateDateObj
                ? createDateObj
                : updateDateObj
            : createDateObj || updateDateObj;

    if (mostRecentForProduct && mostRecentForProduct.getTime() > compareDate.getTime()) {
        return mostRecentForProduct;
    }

    return null;
}
